export const LOGIN = 'LOGIN';
export const LOGIN_STARTED = 'LOGIN_STARTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const USER_TOKEN_REFRESH = 'USER_TOKEN_REFRESH';
export const USER_TOKEN_REFRESH_STARTED = 'USER_TOKEN_REFRESH_STARTED';
export const USER_TOKEN_REFRESH_SUCCESS = 'USER_TOKEN_REFRESH_SUCCESS';
export const USER_TOKEN_REFRESH_FAILED = 'USER_TOKEN_REFRESH_FAILED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_STARTED = 'LOGOUT_STARTED';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const USER_INFO = 'USER_INFO';
export const USER_INFO_STARTED = 'USER_INFO_STARTED';
export const USER_INFO_SUCCESS = 'USER_INFO_SUCCESS';
export const USER_INFO_FAILED = 'USER_INFO_FAILED';
export const SET_USER_REALM = 'SET_USER_REALM';
export const SET_USER_PERMISSION = 'SET_USER_PERMISSION';
export const SET_ACCOUNT_SETTINGS = 'SET_ACCOUNT_SETTINGS';

export const SET_FILTER = 'SET_FILTER';
export const SET_ALL_FILTER = 'SET_ALL_FILTER';

export const CLEAR_DATA = 'CLEAR_DATA';
export const CLEAR_META = 'CLEAR_META';

export const SET_VIEW = 'SET_VIEW';
export const SET_DATA = 'SET_DATA';
export const SET_HARD_DATA = 'SET_HARD_DATA';
